/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { CloseIcon, UserIcon } from 'assets/icons';
import { Input, Select, SelectActions, Textarea } from 'components';
import { Globals } from 'utils';
import { DocBox } from './components';
import { GeneralService, ServicesService, UsersService } from 'services';

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

interface ModalEditDoctorProps {
  user?: any
  onClose: (reload?: boolean) => void
}

interface FormProps {
  user_id: string
  photo?: File
  photo_blob: string
  name: string
  lastname: string
  document_type_id: string
  document: string
  phonecode_id: string
  phone: string
  email: string
  specialty_id: string
  experience: string
  address: string
  document_photo?: File
  document_photo_blob: string
  medic_document_photo?: File
  medic_document_photo_blob: string
  university_degree_photo?: File
  university_degree_photo_blob: string
  article_8_photo?: File
  article_8_photo_blob: string
  culmination_photo?: File
  culmination_photo_blob: string
  hasFile: boolean
}

const ModalEditDoctor = ({ user, onClose }: ModalEditDoctorProps) => {

  const debounce = useRef<NodeJS.Timeout>();
  const [search, setSearch] = useState('');
  const [specialties, setSpecialties] = useState<any[]>([]);
  const [documentTypes, setDocumentTypes] = useState<any[]>([]);
  const [phoneCodes, setPhoneCodes] = useState<any[]>([]);
  const [form, setForm] = useState<FormProps>({
    user_id: '',
    // photo: undefined,
    photo_blob: '',
    name: '',
    lastname: '',
    document_type_id: '',
    document: '',
    phonecode_id: '',
    phone: '',
    email: '',
    specialty_id: '',
    experience: '',
    address: '',
    // document_photo: undefined,
    document_photo_blob: '',
    // medic_document_photo: undefined,
    medic_document_photo_blob: '',
    // university_degree_photo: undefined,
    university_degree_photo_blob: '',
    // article_8_photo: undefined,
    article_8_photo_blob: '',
    // culmination_photo: undefined,
    culmination_photo_blob: '',
    hasFile: true,
  });

  const onChange = (value: string | File, target: keyof typeof form) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const getSelects = () => {
    Promise.all([
      GeneralService.getDocumentTypes(),
      GeneralService.getPhoneCodes(),
    ])
      .then((res: any[]) => {
        setDocumentTypes(res[0].map((x: any) => ({ value: String(x.id), label: x.name })) ?? []);
        setPhoneCodes(res[1].map((x: any) => ({ value: String(x.id), label: x.name })) ?? []);
      })
      .catch(console.log);
  }

  const getSpecialties = async () => {
    const toSelect = (data: any) => data?.map((x: any) => ({ value: x.id, label: x.name })) ?? [];

    try {
      const res: any = await ServicesService.getSelects({ withoutLoading: true, search });
      setSpecialties(toSelect(res?.specialties));

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  };

  const validateForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!form.name)
      return Globals.showError('Debe ingresar el nombre');

    if (!form.lastname)
      return Globals.showError('Debe ingresar el apellido');

    if (!form.phone)
      return Globals.showError('Debe ingresar el teléfono');

    if (!form.email)
      return Globals.showError('Debe ingresar el correo');

    if (!form.specialty_id)
      return Globals.showError('Debe ingresar la especialidad');

    if (!form.experience)
      return Globals.showError('Debe ingresar la experiencia');

    if (!form.document_type_id)
      return Globals.showError('Debe ingresar el tipo de documento');

    if (!form.document)
      return Globals.showError('Debe ingresar la cédula de identidad');

    if (!form.address)
      return Globals.showError('Debe ingresar la dirección');

    onSubmit();
  }

  const onSubmit = async () => {
    try {
      await UsersService.updateDoctor(form);
      Globals.showSuccess('Datos actualizados');
      onClose(true);

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  useEffect(() => {
    getSpecialties();
    getSelects();

    setForm({
      user_id: user.id,
      photo: user.photo,
      photo_blob: user?.photo ? Globals.fromStorage(user.photo) : '',
      name: user.name,
      lastname: user.lastname,
      document_type_id: user.document_type_id,
      document: user.document,
      phonecode_id: user.phonecode_id,
      phone: user.phone,
      email: user.email,
      specialty_id: user.specialty_id,
      experience: user.experience,
      address: user.address,
      document_photo: undefined,
      document_photo_blob: user?.document_photo ? Globals.fromStorage(user.document_photo) : '',
      medic_document_photo: undefined,
      medic_document_photo_blob: user?.medic_document_photo ? Globals.fromStorage(user.medic_document_photo) : '',
      university_degree_photo: undefined,
      university_degree_photo_blob: user?.university_degree_photo ? Globals.fromStorage(user.university_degree_photo) : '',
      article_8_photo: undefined,
      article_8_photo_blob: user?.article_8_photo ? Globals.fromStorage(user.article_8_photo) : '',
      culmination_photo: undefined,
      culmination_photo_blob: user?.culmination_photo ? Globals.fromStorage(user.culmination_photo) : '',
      hasFile: true,
    });
  }, []);

  return (
    <form onSubmit={validateForm}>
      <header>
        <p className="title">Editar</p>
        <button type="button" className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <section className="head">
        <div className="user-photo">
          {form.photo_blob ? (
            <img src={form.photo_blob} alt="Usuario" />
          ) : (
            <img className="user-icon" src={UserIcon} alt="Usuario" />
          )}
        </div>
      </section>

      <section className="body">
        <Input
          label="Nombres"
          value={form.name}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'name')}
        />
        <Input
          label="Apellidos"
          value={form.lastname}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'lastname')}
        />
        <div className="document-group">
          <Select
            label="C.I."
            name="document_type_id"
            placeholder=" "
            value={form.document_type_id}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'document_type_id')}
            options={documentTypes}
          />
          <Input
            value={form.document}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'document')}
          />
        </div>
        <div className="phone-group">
          <Select
            label="Teléfono"
            name="phonecode_id"
            placeholder=" "
            value={form.phonecode_id}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'phonecode_id')}
            options={phoneCodes}
          />
          <Input
            value={form.phone}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'phone')}
          />
        </div>
        <Input
          label="Correo"
          value={form.email}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'email')}
        />
        <SelectActions
          label="Especialidad"
          placeholder="Seleccione"
          isSearchable
          onInputChange={v => {
            setSearch(v);
            onChange('', 'specialty_id');
            if (debounce.current) clearTimeout(debounce.current);
            debounce.current = setTimeout(() => getSpecialties(), 800);
          }}
          options={specialties}
          value={form.specialty_id}
          onChange={v => onChange(v, 'specialty_id')}
        />
        <Input
          type="number"
          label="Experiencia (años)"
          value={form.experience}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'experience')}
        />
        <div />

        <div className="col-x2">
          <Textarea
            rows={2}
            label="Dirección"
            value={form.address}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'address')}
          />
        </div>

        <div className="col-x2">
          <p className="section-title">Documentos</p>
        </div>
        <DocBox
          label="Cédula de identidad"
          file={form.document_photo_blob}
          fileName="Documento"
          isPDF={String(form.document_photo?.type ?? form.document_photo_blob ?? '').endsWith('pdf')}
          onChange={e => {
            if (e.target.files?.length) {
              onChange(e?.target?.files[0], 'document_photo');
              onChange(URL.createObjectURL(e?.target?.files[0]), 'document_photo_blob');
              e.target.value = '';
            }
          }}
        />
        <DocBox
          label="Carnet Médico"
          file={form.medic_document_photo_blob}
          fileName="Documento"
          isPDF={String(form.medic_document_photo?.type ?? form.medic_document_photo_blob ?? '').endsWith('pdf')}
          onChange={e => {
            if (e.target.files?.length) {
              onChange(e?.target?.files[0], 'medic_document_photo');
              onChange(URL.createObjectURL(e?.target?.files[0]), 'medic_document_photo_blob');
              e.target.value = '';
            }
          }}
        />
        <DocBox
          label="Título Universitario"
          file={form.university_degree_photo_blob}
          fileName="Documento"
          isPDF={String(form.university_degree_photo?.type ?? form.university_degree_photo_blob ?? '').endsWith('pdf')}
          onChange={e => {
            if (e.target.files?.length) {
              onChange(e?.target?.files[0], 'university_degree_photo');
              onChange(URL.createObjectURL(e?.target?.files[0]), 'university_degree_photo_blob');
              e.target.value = '';
            }
          }}
        />
        <DocBox
          label="Artículo N°8"
          file={form.article_8_photo_blob}
          fileName="Documento"
          isPDF={String(form.article_8_photo?.type ?? form.article_8_photo_blob ?? '').endsWith('pdf')}
          onChange={e => {
            if (e.target.files?.length) {
              onChange(e?.target?.files[0], 'article_8_photo');
              onChange(URL.createObjectURL(e?.target?.files[0]), 'article_8_photo_blob');
              e.target.value = '';
            }
          }}
        />
        <DocBox
          label="Carta de Culminación"
          file={form.culmination_photo_blob}
          fileName="Documento"
          isPDF={String(form.culmination_photo?.type ?? form.culmination_photo_blob ?? '').endsWith('pdf')}
          onChange={e => {
            if (e.target.files?.length) {
              onChange(e?.target?.files[0], 'culmination_photo');
              onChange(URL.createObjectURL(e?.target?.files[0]), 'culmination_photo_blob');
              e.target.value = '';
            }
          }}
        />
      </section>

      <div className="actions">
        <button>Guardar</button>
      </div>
    </form>
  );
}

export default ModalEditDoctor;